import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "@/api/services/Settings/apiEndpoint";
import { baseQueryWithInterceptor } from "@/utils/customBaseQuery";
import { baseApi } from "@/utils/baseApi";

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSettingsForm: builder.query({
      query: (name) => ({
        url: API_ENDPOINTS.SETTINGS.FETCH_SETTINGS_FORM(name),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "SettingFormValue", id: "LIST" }]
          : [{ type: "SettingFormValue", id: "LIST" }],
    }),
    fetchSettingsRows: builder.query({
      query: (name) => ({
        url: API_ENDPOINTS.SETTINGS.FETCH_SETTINGS_ROWS(name),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "SettingsFormData", id: "LIST" }]
          : [{ type: "SettingsFormData", id: "LIST" }],
    }),
    postAddSettings: builder.mutation({
      query: ({ formData, name }) => ({
        url: API_ENDPOINTS.SETTINGS.ADD_SETTINGS(name),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),
    postUpdateSettings: builder.mutation({
      query: ({ formData, id, name }) => {
        return {
          url: API_ENDPOINTS.SETTINGS.UPDATE_SETTINGS(id, name),
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),
    postUpdateStatusSettings: builder.mutation({
      query: ({ id, status, name }) => {
        return {
          url: `${API_ENDPOINTS.SETTINGS.UPDATE_SETTINGS_STATUS(
            id,
            status,
            name
          )}`,
          method: "PUT",
        };
      },
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),
    deleteSettings: builder.mutation({
      query: ({ id, name }) => ({
        url: API_ENDPOINTS.SETTINGS.DELETE_SETTINGS(id, name),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),

    // module settings
    fetchModuleSettingsForm: builder.query({
      query: (name) => ({
        url: API_ENDPOINTS.MODULE_SETTINGS.FETCH_MODULE_FORM(name),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "SettingFormValue", id: "LIST" }]
          : [{ type: "SettingFormValue", id: "LIST" }],
    }),

    fetchModuleSettingsData: builder.query({
      query: (name) => ({
        url: API_ENDPOINTS.MODULE_SETTINGS.FETCH_MODULE_DATA(name),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "SettingsFormData", id: "LIST" }]
          : [{ type: "SettingsFormData", id: "LIST" }],
    }),

    postModuleSettings: builder.mutation({
      query: ({ formData, name }) => ({
        url: API_ENDPOINTS.MODULE_SETTINGS.ADD_SETTINGS(name),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),

    updateModuleSettings: builder.mutation({
      query: ({ formData, id, name }) => {
        return {
          url: API_ENDPOINTS.MODULE_SETTINGS.UPDATE_SETTINGS(id, name),
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),

    deleteModuleSettings: builder.mutation({
      query: ({ id, name }) => ({
        url: API_ENDPOINTS.MODULE_SETTINGS.DELETE_SETTINGS(id, name),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),

    updateStatusModuleSettings: builder.mutation({
      query: ({ id, status, name }) => {
        return {
          url: `${API_ENDPOINTS.MODULE_SETTINGS.UPDATE_SETTINGS_STATUS(
            id,
            status,
            name
          )}`,
          method: "PUT",
        };
      },
      invalidatesTags: [{ type: "SettingsFormData", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchSettingsFormQuery,
  useFetchSettingsRowsQuery,
  usePostAddSettingsMutation,
  usePostUpdateSettingsMutation,
  usePostUpdateStatusSettingsMutation,
  useDeleteSettingsMutation,

  // module settings
  useFetchModuleSettingsFormQuery,
  useFetchModuleSettingsDataQuery,
  usePostModuleSettingsMutation,
  useUpdateModuleSettingsMutation,
  useDeleteModuleSettingsMutation,
  useUpdateStatusModuleSettingsMutation,
} = settingsApi;
